import 'react';
import { Box, Stack, Typography, FormHelperText } from '@mui/material';
import { jsxs, jsx } from 'react/jsx-runtime';

const FormLabelField = props => {
  const {
    label,
    secondaryAction,
    children,
    sx,
    divider
  } = props;
  return /*#__PURE__*/jsxs(Box, {
    component: "label",
    sx: {
      cursor: 'pointer',
      display: 'block',
      '&:not(:last-child)': {
        borderBottom: theme => divider ? `1px solid ${theme.palette.divider}` : 'none'
      },
      ...sx
    },
    children: [/*#__PURE__*/jsxs(Stack, {
      direction: "row",
      alignItems: "center",
      sx: {
        minHeight: theme => theme.spacing(6)
      },
      children: [/*#__PURE__*/jsxs(Box, {
        sx: {
          width: '100%'
        },
        children: [/*#__PURE__*/jsx(Typography, {
          variant: "body02",
          sx: {
            userSelect: 'none'
          },
          children: label
        }), /*#__PURE__*/jsx(FormHelperText, {
          sx: {
            mt: 0,
            color: theme => theme.palette.primary.main,
            userSelect: 'none'
          },
          children: props.helperText
        })]
      }), /*#__PURE__*/jsx(Box, {
        children: secondaryAction
      })]
    }), /*#__PURE__*/jsx(Box, {
      className: "Mui-FormLabelField-Content",
      children: children
    })]
  });
};

export { FormLabelField };
